const colleguePath = 'collaboratingCollegues.';

const collegueTrans = {
    PARTNERSHIP_IS_ESSENTIAL: colleguePath + 'partnershipEssential',
    PARTNERSHIP_IS_ESSENTIAL_DESCRIPTION: colleguePath + 'partnershipEssentialDesc',
    PARTNERSHIP_IS_ESSENTIAL_SUB_TITLE: colleguePath + 'partnershipEssentialSubTitle',

    GET_STARTED: colleguePath + 'getStarted',
    GET_STARTED_DESCRIPTION: colleguePath + 'getStartedDescription',
    PATIENT_IDENTIFICATION: colleguePath + 'patientIdentification'
}

export default collegueTrans